module.exports = __webpack_public_path__ + "static/media/hallazgos-santa-reliquia-virgen-coromoto.a80ea579.png";